import { render, staticRenderFns } from "./InvalidSignature.vue?vue&type=template&id=627b7026&"
import script from "./InvalidSignature.vue?vue&type=script&lang=js&"
export * from "./InvalidSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('627b7026')) {
      api.createRecord('627b7026', component.options)
    } else {
      api.reload('627b7026', component.options)
    }
    module.hot.accept("./InvalidSignature.vue?vue&type=template&id=627b7026&", function () {
      api.rerender('627b7026', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/InvalidSignature.vue"
export default component.exports